import { createApp } from 'vue';
import LocaleSwitcher from './LocaleSwitcher.vue';
import { i18n } from '../../i18n';

// Desktop navbar dropdown, and the row in the mobile off-canvas menu. Each is
// its own app so a page can render either mount point without the other.
const mounts: Array<[string, 'dropdown' | 'inline']> = [
  ['locale-switcher', 'dropdown'],
  ['locale-switcher-mobile', 'inline'],
];

mounts.forEach(([id, variant]) => {
  if (!document.getElementById(id)) return;

  const app = createApp(LocaleSwitcher, { variant });
  app.use(i18n);
  app.mount(`#${id}`);
});
